/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Application_Overview_TitleInputs */

const en_landing_application_overview_title = /** @type {(inputs: Landing_Application_Overview_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Application overview`)
};

const de_landing_application_overview_title = /** @type {(inputs: Landing_Application_Overview_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bewerbungsübersicht`)
};

const fr_landing_application_overview_title = /** @type {(inputs: Landing_Application_Overview_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vue d’ensemble des candidatures`)
};

const es_landing_application_overview_title = /** @type {(inputs: Landing_Application_Overview_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resumen de solicitudes`)
};

const it_landing_application_overview_title = /** @type {(inputs: Landing_Application_Overview_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Panoramica delle candidature`)
};

const nl_landing_application_overview_title = /** @type {(inputs: Landing_Application_Overview_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sollicitatieoverzicht`)
};

const pl_landing_application_overview_title = /** @type {(inputs: Landing_Application_Overview_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Przegląd aplikacji`)
};

const fi_landing_application_overview_title = /** @type {(inputs: Landing_Application_Overview_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hakemusten yleiskatsaus`)
};

const da_landing_application_overview_title = /** @type {(inputs: Landing_Application_Overview_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ansøgningsoversigt`)
};

const sv_landing_application_overview_title = /** @type {(inputs: Landing_Application_Overview_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ansökningsöversikt`)
};

/**
* | output |
* | --- |
* | "Application overview" |
*
* @param {Landing_Application_Overview_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_application_overview_title = /** @type {((inputs?: Landing_Application_Overview_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Application_Overview_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_application_overview_title(inputs)
	if (locale === "fr") return fr_landing_application_overview_title(inputs)
	if (locale === "es") return es_landing_application_overview_title(inputs)
	if (locale === "it") return it_landing_application_overview_title(inputs)
	if (locale === "nl") return nl_landing_application_overview_title(inputs)
	if (locale === "pl") return pl_landing_application_overview_title(inputs)
	if (locale === "fi") return fi_landing_application_overview_title(inputs)
	if (locale === "da") return da_landing_application_overview_title(inputs)
	if (locale === "sv") return sv_landing_application_overview_title(inputs)
	return en_landing_application_overview_title(inputs)
});